import React from 'react'
import { connect } from 'react-redux'
import { changeExample, deleteExample, saveExample } from '../../actioncreators/actioncreators'
import swal from 'sweetalert'
import truncate from 'truncate'
const { Component } = React

class Example extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      hover: false
    }

    this.exampleInput = React.createRef()
  }

  componentDidMount () {
    if (this.props.allowAutofocus) {
      this.exampleInput.current.focus()
    }
  }

  render () {
    return (
      <li className='list-group-item' style={{ backgroundColor: 'inherit', border: 'none', marginTop: 0, display: 'flex', padding: 7 }}
        onMouseOver={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}>
        <div style={{ backgroundColor: '#14B300', width: 7, margin: '0px 7px 0px 0px' }}>&nbsp;</div>
        <div style={{ padding: '0px', flexGrow: 1 }}>
          <textarea
            className='form-control'
            rows='4'
            value={this.props.example}
            onChange={this.props.onChange}
            onBlur={this.props.saveExample}
            style={{ resize: 'vertical', padding: 6 }}
            placeholder='Enter an example which illustrates the rule'
            ref={this.exampleInput} />
          <button className={this.state.hover ? 'btn btn-default btn-xs' : 'hidden btn btn-default btn-xs'}
            style={{ position: 'absolute', top: 2, right: 2, zIndex: '100' }}
            onClick={this.props.deleteExample}
            title='Delete rule'>
            <span className='glyphicon glyphicon-trash' aria-hidden='true' />
          </button>
        </div>
      </li>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    example: ownProps.example.text,
    allowAutofocus: store.exampleMap.allowAutofocus
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    onChange: function (event) {
      dispatch(changeExample(ownProps.example.id, event.target.value))
    },
    deleteExample: function () {
      if (ownProps.example.text.length === 0){
        dispatch(deleteExample(ownProps.example.id))
        return
      }
      swal({
        title: 'Delete this example?',
        text: `Click OK to delete "${truncate(ownProps.example.text, 30)}"`,
        icon: 'warning',
        buttons: true
      })
        .then((willDelete) => {
          if (willDelete) {
            dispatch(deleteExample(ownProps.example.id))
          }
        })
    },
    saveExample: function () {
      dispatch(saveExample())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Example)
